import styled from 'styled-components';

import { Box } from '../../../../../../components/Layout';

export const Container = styled.div``;

export const ThumbnailBox = styled(Box)`
    padding-top: 0;
`;
